import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e6db7d08&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=e6db7d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6db7d08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6db7d08')) {
      api.createRecord('e6db7d08', component.options)
    } else {
      api.reload('e6db7d08', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e6db7d08&scoped=true&", function () {
      api.rerender('e6db7d08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/work_order/order/index.vue"
export default component.exports